// Vendor Components
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {isArray, map} from 'lodash';

// Redux Actions
import {globalResponseReset} from '../../actions/global-response-actions';

// Components
import Drawer from './drawer';

// Styles
import './global-response.scss';

function GlobalResponse({autoClose=false, className, error, globalResponseReset, success}) {
    const getClass = () =>
        classnames(
            {
                'global-response': true,
            },
            className
        );

    const handleClose = () => {
        globalResponseReset();
    };

    const renderErrors = (error) => (error ? renderResponses(error, 'errors') : null);

    const renderResponses = (responses, type) => {
        const responsesArray = isArray(responses) ? responses : [responses];

        return responsesArray.length ? (
            <div className={`global-response--${type}`}>
                {map(responsesArray, (response, key) => (
                    <div key={key}>{response}</div>
                ))}
            </div>
        ) : null;
    };

    const renderSuccess = (success) => (success ? renderResponses(success, 'success') : null);

    return error || success ? (
        <Drawer autoClose={autoClose} className={getClass()} onClose={handleClose}>
            {renderErrors(error)}
            {renderSuccess(success)}
        </Drawer>
    ) : null;
}

GlobalResponse.propTypes = {
    autoClose: PropTypes.bool,
    className: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    globalResponseReset: PropTypes.func.isRequired,
    success: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

const mapStateToProps = ({globalResponse}) => globalResponse;

const mapDispatchToProps = {
    globalResponseReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalResponse);
